import React from "react";
import "./BattleCard.css";

function resolveStatusClass(resultKey = "") {
  const normalized = String(resultKey).toLowerCase();

  if (normalized === "win" || normalized === "victory") {
    return "is-victory";
  }

  if (normalized === "lose" || normalized === "loss" || normalized === "defeat") {
    return "is-defeat";
  }

  if (normalized === "draw") {
    return "is-draw";
  }

  return "";
}

const BattleCard = ({ attempts = [], onAction, onViewAll, compactMobile = false, showHeading = true, rejoiningRoomId = 0 }) => {
  const hasAttempts = Array.isArray(attempts) && attempts.length > 0;

  return (
    <div className={compactMobile ? "battle-activity battle-activity--compact-mobile" : "battle-activity"}>
      <div>
        {showHeading ? (
          <div className="attempteds-heading mt-3 battle-activity__heading">
            <h3>Attempts</h3>
            {onViewAll ? <button type="button" className="battle-activity__view-all" onClick={onViewAll}>View All</button> : null}
          </div>
        ) : null}

        {hasAttempts ? (
          <>
            <div className="group-battle-grid">
              {attempts.map((battle) => {
                const statusClassName = resolveStatusClass(battle.resultKey);
                const actionLabel = battle.resultKey === "Rejoin" ? "Rejoin" : battle.resultKey === "Ongoing" ? "Details" : "View";
                const coinDelta = battle.coinDelta || "-";
                const roomCode = battle.roomCode
                  ? `#${String(battle.roomCode).replace(/^#/, "")}`
                  : "-";

                return (
                  <div className="group-battle-card" role="button" tabIndex={0}
                    onClick={() => onAction?.(battle)}
                    onKeyDown={(event) => { if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); onAction?.(battle); } }}
                    key={battle.battleRoomId || `${battle.id}-${battle.subjectId}`}>
                    <div className="battle-card-top">
                      <div className="battle-info">
                        <div className={`battle-icon ${battle.color}`}>
                          <i className="bi bi-trophy-fill"></i>
                        </div>

                        <div className="battleTitle">
                          <h3>{battle.title}</h3>
                          <span>{`(${battle.battleType})`}</span>
                        </div>
                      </div>

                      <div className={`battle-status ${statusClassName}`}>{battle.status}</div>
                    </div>

                    <div className="battle-date">
                      <i className="bi bi-clock"></i>
                      <span>{battle.attemptedAt}</span>
                    </div>

                    <div className="battle-stats">
                      <div className="battle-stat">
                        <strong>{roomCode}</strong>
                        <span>Room Code</span>
                      </div>

                      <div className="battle-divider"></div>

                      <div className="battle-stat battle-stat-center">
                        <strong>{battle.score}</strong>
                        <span>Score</span>
                      </div>

                      <div className="battle-divider"></div>

                      <div className="battle-stat battle-stat-right">
                        <strong>{battle.rank}</strong>
                        <span>Rank</span>
                      </div>
                    </div>

                    <div className="battle-card-footer">
                      <span className={`battle-coin-delta ${coinDelta.startsWith("+") ? "is-positive" : coinDelta.startsWith("-") ? "is-negative" : ""}`}>
                        {coinDelta === "-" ? "No coin change" : `${coinDelta} Coins`}
                      </span>
                      <button
                        type="button"
                        className="attempted-review-btn"
                        disabled={rejoiningRoomId === battle.battleRoomId}
                        onClick={(event) => { event.stopPropagation(); onAction?.(battle); }}
                      >
                        {rejoiningRoomId === battle.battleRoomId ? "Rejoining..." : actionLabel}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

          </>
        ) : (
          <div className="battle-empty-state">No battles attempted yet.</div>
        )}
      </div>
    </div>
  );
};

export default BattleCard;
